import { Link } from 'react-router-dom';
import { Box, Truck, Thermometer, Snowflake, Wind, Wrench } from 'lucide-react';
import './Fleet.css';

const fleets = [
  { Icon: Box,         tag: 'Non-Temp',       tagColor: '#6366f1', name: 'Aluminum Box',    price: '19,900', features: ['Dry cargo',          'Lockable box',       'Custom wrap'] },
  { Icon: Truck,       tag: 'Non-Temp',       tagColor: '#6366f1', name: 'Cargo Box',       price: '21,900', features: ['High capacity',      'Roll-up door',       'Fleet GPS'] },
  { Icon: Thermometer, tag: '+25°C',           tagColor: '#f59e0b', name: 'Temp Controlled', price: '27,000', features: ['Ambient control',    'Pharma ready',       'IoT sensors'] },
  { Icon: Snowflake,   tag: '2–8°C',           tagColor: '#0ea5e9', name: 'Cold Chain',      price: '32,000', features: ['Medical grade',      'GDP compliant',      'Real-time temp'] },
  { Icon: Wind,        tag: '−18 to −25°C',    tagColor: '#2563eb', name: 'Frozen',          price: '38,000', features: ['Deep freeze',        'GDPMD ready',        'Backup cooling'] },
  { Icon: Wrench,      tag: 'Custom Build',    tagColor: '#64748b', name: 'Skeleton',        price: '16,900', features: ['Custom build',       'Flatbed option',     'Bulk cargo'] },
];

export default function Fleet() {
  return (
    <section className="fleet-section" id="fleet">
      <div className="fleet-header">
        <span className="section-label">Fleet Solutions</span>
        <h2 className="section-title">Six Options.<br />Every Business Need.</h2>
        <p className="section-desc">
          Choose from our range of fully managed EV trucks — from dry cargo to deep-freeze cold chain.
          All vehicles include insurance, maintenance, GPS, and Axion OS.
        </p>
      </div>

      <div className="fleet-grid">
        {fleets.map(({ Icon, tag, tagColor, name, price, features }) => (
          <div key={name} className="fleet-card">
            <div className="fleet-card-top">
              <span className="fleet-tag" style={{ background:`${tagColor}14`, color:tagColor, border:`1px solid ${tagColor}38` }}>
                {tag}
              </span>
              <div className="fleet-icon" style={{ background:`${tagColor}12`, color:tagColor }}>
                <Icon size={26} strokeWidth={1.6} />
              </div>
            </div>
            <h3 className="fleet-name">{name}</h3>
            <p className="fleet-price">
              From <strong>{price}</strong> <span>THB/mo</span>
            </p>
            <ul className="fleet-features">
              {features.map(f => (
                <li key={f}><span className="fleet-check">✓</span>{f}</li>
              ))}
            </ul>
            <Link to="/contact" className="fleet-cta">Get a Quote →</Link>
          </div>
        ))}
      </div>

      <div className="fleet-footer">
        <span>*Costs vary based on usage and vehicle type.</span>
        <Link to="/contact" className="fleet-all">Request Full Fleet Catalogue →</Link>
      </div>
    </section>
  );
}
